module.exports = __webpack_public_path__ + "static/media/mpl-logo.bb4da590.png";